import { profileLocal } from './profiles/local';
const KEY = 'vp-canvas-opens';

function read(): Record<string, number> {
  try {
    const raw = profileLocal.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    const out: Record<string, number> = {};
    for (const [id, n] of Object.entries(parsed)) if (typeof n === 'number' && n > 0) out[id] = n;
    return out;
  } catch {
    return {};
  }
}

/** How many times each canvas was opened in this browser. */
export function canvasOpens(): Record<string, number> {
  return read();
}

export function noteCanvasOpen(id: string): void {
  const map = read();
  map[id] = (map[id] ?? 0) + 1;
  try {
    profileLocal.setItem(KEY, JSON.stringify(map));
  } catch {
    /* storage full or blocked */
  }
}

export function forgetCanvasOpen(id: string): void {
  const map = read();
  if (!(id in map)) return;
  delete map[id];
  try {
    profileLocal.setItem(KEY, JSON.stringify(map));
  } catch {
    /* storage blocked */
  }
}
